import { render, staticRenderFns } from "./bdd-checklists.vue?vue&type=template&id=9348f1e6"
import script from "./bdd-checklists.vue?vue&type=script&lang=js"
export * from "./bdd-checklists.vue?vue&type=script&lang=js"
import style0 from "./bdd-checklists.vue?vue&type=style&index=0&id=9348f1e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports